import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment from 'moment';
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';

import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app';
import { TripDate, TripItem } from 'src/app/model';
import { DataService } from 'src/app/services/data.service';
import { GeneralService } from 'src/app/services/general.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-trip-history-details',
  templateUrl: './trip-history-details.component.html',
  styleUrl: './trip-history-details.component.css'
})
export class TripHistoryDetailsComponent {

  public entityId = this.route?.url?.split('/')?.[3];

  popRoute: boolean = false;
  masterMapData: any = [];
  datePicker = new FormControl(new Date());
  maxDate: Date = new Date();
  minDate: Date = this._generalService.getPreviousDateByType('day', 7);
  selectedDate: { tripId: string; start: string; end: string } | Date;
  showControls: boolean = false;
  dialogRef: any;
  activeDates: TripDate[] = [];
  entityDetails: any;
  defaultImage: string;
  private _tenantGenericConfig: any;
  public imageLoaded = false;
  selectedTripIndex: number = 0;
  public datepickerForm: FormGroup;
  private _selectedDates = {
    from: null,
    to: null,
  };
  tripInsightsData : TripItem[] = [];


  private _routeData: any;
  private _isloader: boolean = false;
  private _tenantConfig: any;
  private _getEntityDetailsSubscription: Subscription;
  private _getGeoHistorySubscription: Subscription;
  private _getActiveDatesSubscription: Subscription;
  private _dataServiceSubscription: Subscription;
  private _getInsightsSubscription: Subscription;

  constructor(
    private _service: EntitiesServiceService,
    public _dialog: MatDialog,
    private _generalService: GeneralService,
    private _dataService: DataService,
    private _datePipe: DatePipe,
    public sharedService: ServicecallService,
    private _fb: FormBuilder,
    private route: Router
  ) {
    this._dataServiceSubscription = this._dataService.events.subscribe((res: any) => {
      if (res.name === 'apiRefresh' || res.name === 'siteChanged') {
        this._getEntitiesDetails();
        this.getActiveDates();
      }
    });
  }

  ngOnInit(): void {
    // this.getRouteData();
    this._tenantGenericConfig = this.sharedService.getConfiguration('tenantGenericConfig') ? this.sharedService.getConfiguration('tenantGenericConfig') : null;
    this._initializeForm();
    const { startDate, endDate } = this.sharedService.getVehicleDateRange() ? {startDate: new Date(this.sharedService.getVehicleDateRange()?.startDate), endDate: new Date(this.sharedService.getVehicleDateRange()?.endDate) } : this.getDateRange(this._tenantGenericConfig?.tripHistoryDefaultTime ?? 'today');

    this.datepickerForm.setValue({
      thisdate: { startDate, endDate }
    });
    this._selectedDates = { from: startDate, to: endDate };
    this._getEntitiesDetails();
    this.getActiveDates();
  }

  private _initializeForm(type: string = 'default') {
    this.datepickerForm = this._fb.group({
      thisdate: null
    });
  }

  getDateRange(rangeType) {
    const now = new Date();
    const defaultTimeRange = this.sharedService.getConfiguration('tenantGenericConfig')?.defaultTimeRange || 0;
    let startDate;
    let endDate;
    
    switch(rangeType) {
      case 'today':
        let configStartDate = null;
        let configEndDate = null;
    
        if (defaultTimeRange) {
          const configHour = this._tenantGenericConfig?.defaultTimeRange || 0;
    
        const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
          configEndDate = endDate;
          configStartDate = startDate;
        }
        startDate = configStartDate;
        endDate = configEndDate;
        break;
        
      case 'yesterday':
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, defaultTimeRange, 0, 0, 0);
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() , defaultTimeRange, 0, 0, 0);
        break;
        
      case 'last7days':
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6, defaultTimeRange, 0, 0, 0);
        endDate = new Date();
        break;
        
      case 'thisweek':
        const dayOfWeek = now.getDay(); 
        const firstDayOfWeek = 0; 
        const diff = (dayOfWeek - firstDayOfWeek + 7) % 7;
        startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - diff, defaultTimeRange, 0, 0, 0);
        endDate = new Date();
        break;
        
      case 'thismonth':
        startDate = new Date(now.getFullYear(), now.getMonth(), 1, defaultTimeRange, 0, 0, 0);
        endDate = new Date();
        break;
        
      default:
        startDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          defaultTimeRange, 
          0, 0, 0
        );
        endDate = new Date();
        break;
    }
    
    return {startDate, endDate};
  }

  ngOnDestroy(): void {
    this._getEntityDetailsSubscription?.unsubscribe();
    this._getGeoHistorySubscription?.unsubscribe();
    this._getActiveDatesSubscription?.unsubscribe();
    this._dataServiceSubscription?.unsubscribe();
    this._getInsightsSubscription?.unsubscribe();
  }


  /**
     * Gets entities details (To fetch category specific tenant config)
     */
  private _getEntitiesDetails() {
    const entityId = { entityId: this.entityId };
    this._getEntityDetailsSubscription = this.sharedService.getEntityDetails(entityId).subscribe((result: any) => {
      if (result.status) {
        this.entityDetails = result?.response?.data[0];
        this._tenantGenericConfig = this.sharedService.getConfiguration('tenantGenericConfig') ? this.sharedService.getConfiguration('tenantGenericConfig') : null;
        const configBasedOnCategory = this.sharedService.getConfigurationBasedOnCategory(this.entityDetails);
        this.defaultImage = configBasedOnCategory?.defaultImage ? configBasedOnCategory?.defaultImage?.[this.entityDetails?.category] : this._tenantGenericConfig?.defaultImage?.[this.entityDetails?.category];
      } else {
        this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  onImageLoad(): void {
    this.imageLoaded = true;
  }

  onImageError(): void {
    this.imageLoaded = false;
  }

  /**
   * Gets geo history
   */
  getGeoHistory(index?: number) {
    let startTime;
    let endTime;
    if(this._tenantGenericConfig?.tripHistoryProfilingBasedOn === 'tripId') {
      startTime = this.activeDates?.[index ?? 0]?.['start'];
      endTime =  this.activeDates?.[index ?? 0]?.['end'];
    } else {
      [startTime, endTime] = this._generalService?.getStartEndTimeForSelectedDate(this.activeDates?.[index ?? 0], this._tenantGenericConfig?.tenant, this._tenantGenericConfig?.defaultTimeRange);
    }

    const _reqPayload = {
      entityId: this.entityId,
      from: this._datePipe.transform(startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(endTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this._getGeoHistorySubscription = this._service
      .getGeoHistory(_reqPayload)
      .subscribe((result: any) => {
        if (result.length) {
          const coordArray = result.map((data: any) => [
            data?.coordinates?.lat,
            data?.coordinates?.long,
          ]);
          this.masterMapData = [
            {
              polygonData: coordArray,
            },
          ];
        } else {
          this.masterMapData = [];
        }
      });
  }

  /**
   * Dates change
   * @param event
   */
  // dateChange(event: MatDatepickerInputEvent<Date>) {
  //   this.selectedDate = event?.value;
  //   this.getGeoHistory();
  // }

  /**
   * Enables draw controls
   */
  enableDrawControls() {
    this.showControls = !this.showControls;
  }

  /**
   * Geos fence values
   * @param event 
   */
  geoFenceValues(event: []) {
    this._dataService.broadcast('zoneAdded', event);
  }

  public geoTracePlayback() {
    const queryParams = this._selectedDates
      ? new URLSearchParams({ from: new Date(this._selectedDates?.from)?.toISOString(), to: new Date(this._selectedDates?.to)?.toISOString() }).toString()
      : '';

    const url = queryParams
      ? `/vehicles/profile/${this.entityId}/playback?${queryParams}&tripName=Trips`
      : `/vehicles/profile/${this.entityId}/playback?tripName=Trips`;

    this.route.navigateByUrl(url);
  }

  geoTracePlaybackV2() {
    const queryParams = this._selectedDates
      ? new URLSearchParams({ from: new Date(this._selectedDates?.from)?.toISOString(), to: new Date(this._selectedDates?.to)?.toISOString() }).toString()
      : '';

    const url = queryParams
      ? `/vehicles/profile/${this.entityId}/playbackV2?${queryParams}&tripName=Trips`
      : `/vehicles/profile/${this.entityId}/playbackV2?tripName=Trips`;

    this.route.navigateByUrl(url);
  }

  public handleBack() {
    this.route.navigateByUrl(`/vehicles/profile/${this.entityId}`);
  }

  public getActiveDates() {
    const reqPayload = { entityId: this.entityId, count: this._tenantGenericConfig?.tripHistoryCount ?? 3, from: this._datePipe.transform(this._selectedDates?.from, 'yyyy-MM-ddTHH:mm:ssZZ') , to: this._datePipe.transform(this._selectedDates?.to, 'yyyy-MM-ddTHH:mm:ssZZ') , ...(this._tenantGenericConfig?.tripHistoryProfilingBasedOn === 'tripId' && {profilingBasedOn :  'tripId' })};
    this._getActiveDatesSubscription = this._service
      .getActiveDates(reqPayload)
      .subscribe({
        next: (result: any) => {
        if (result.length) {
          if(this._tenantGenericConfig?.tripHistoryProfilingBasedOn === 'tripId') {
            this.activeDates = Array.isArray(result)? [...result]?.map(item => {
              return {
                tripId: item.tripId,
                start: new Date(item.start),
                end: new Date(item.end)
              }
            })?.sort((a: any, b: any) => new Date(b?.start || 0).getTime() - new Date(a?.start || 0).getTime())?.map((item, index, arr) => 
            ({ ...item, tripName: 'Trip ' + (arr.length - index)?.toString()})) : [] ;
          } else {
            this.activeDates = Array.isArray(result)? [...result]?.map(dateStr => {
              const date = new Date(dateStr);
              return date;
            })?.sort((a: any, b: any) => new Date(b).getTime() - new Date(a).getTime()) : [] ;
          }
          if(this._tenantGenericConfig?.tripHistoryProfilingBasedOn === 'tripId') {
            this._getInsights();
          }
            this.getGeoHistory();
          } else {
            this.activeDates = [];
            this.masterMapData = [];
          }
      }, error: () => {
        this.activeDates = [];
        this.masterMapData = [];
      }
    });
  }

  public tripSelected(index: number) {
    this.selectedTripIndex = index;
    this.getGeoHistory(index);
  }

  /**
 * Saves time
 * @param [data] 
 */
  saveTime(data?: any) {
    if (data) {
      let dateRange: TimePeriod = data;
      const offsetTime = new Date().getTimezoneOffset() * 60 * 1000;
      this._selectedDates.from = this._getTimestampInMillisecond(dateRange?.startDate?.toDate()) + (offsetTime)
      this._selectedDates.to = this._getTimestampInMillisecond(dateRange?.endDate?.toDate()) + (offsetTime)
      this.datepickerForm.setValue({
        thisdate: { startDate: this._selectedDates.from, endDate: this._selectedDates.to }
      });
      this.sharedService.setVehicleDateRange({startDate : this._selectedDates.from, endDate: this._selectedDates.to});
    }
    this.getActiveDates();
  }

  /**
   * Gets timestamp in millisecond
   * @param date 
   * @returns timestamp in millisecond 
   */
  private _getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }

  /**
   * Gets trip id
   * @param date 
   * @returns trip id 
   */
  getTripId(date: Date | { tripId: string; start: string; end: string }): string | undefined {
    if (typeof date === 'object' && 'tripId' in date) {
      return date.tripId;
    }
    return undefined;
  }

  /**
   * Gets trip label
   * @param date 
   * @returns trip label 
   */
  getTripLabel(date: Date | { tripId: string; start: any; end: any; tripName ?: string }, index: number, count : number): string | undefined {
    if (typeof date === 'object' && 'tripName' in date) {
      return date.tripName;
    } else {
      return `Trip ${(count - index)}`
    }
  }

  /**
   * Gets insights
   */
  private _getInsights() {
    const _reqPayload = {
      type : 'PrescriptiveInsights_Trip',
      tripIds: this.activeDates?.map((trip:any) => trip?.tripId)
    };
    this._getInsightsSubscription = this.sharedService
    .getInsight(_reqPayload)
    .subscribe({
      next: (result: any) => {
        this.tripInsightsData = Array.isArray(result) ? [...result] : [];
      },
      error: () => {
        this.tripInsightsData = [];
      },
    });
  }

  /**
   * Determines whether insight available
   * @param tripId 
   * @returns  
   */
  isInsightAvailable(tripId: string) {
    return !!this.tripInsightsData?.some(item => item.tripId === tripId);
  }
}
